import { MbeInput } from '@/components/shared';
import { Box, Button, Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { PlainLayout } from '../layout';
import { useForm } from 'react-hook-form';
import type { SubmitHandler } from 'react-hook-form';
import { hasEmptyFields } from '@/utils';
import { ERRORS, emailRegex, ROUTE_PATHS } from '@/constants';
import { Auth } from '@aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { Section } from '../components/Section';

export const PasswordRecover = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToPage = (replace = false, path: string): void => {
    navigate(path, { replace });
  };

  const {
    formState: { errors },
    handleSubmit: submitHandler,
    register,
    watch,
  } = useForm<{ email: string; password: string }>({ mode: 'all', criteriaMode: 'all' });

  const areRequiredFieldsEmpty = hasEmptyFields(watch());
  const isDisabled = !!errors.email?.types || areRequiredFieldsEmpty;

  const handleSubmit: SubmitHandler<{ email: string }> = (data, event): void => {
    event?.preventDefault();

    Auth.forgotPassword(data.email)
      .then((data) => console.log(data))
      .finally(() => {
        goToPage(true, `/${ROUTE_PATHS.checkEmailPasswordRecover}`);
      })
      .catch((error) => console.log(error));
  };

  return (
    <PlainLayout>
      <Box bg="brand.sand" px={8} py={{ base: 8, md: 16 }} w="full">
        <Container bg="white" minW="75%" px={{ base: '5%', md: '10%' }} py="5%">
          <Section
            containerProps={{ py: 0 }}
            headingProps={{ mx: 'auto' }}
            id="password-recover-form"
            title={t('LOGIN.RECOVER_PASSWORD_TITLE')}
          >
            <Text
              fontSize={{ base: 14, md: 18 }}
              mx="auto"
              textAlign="center"
              w={{ base: '100%', md: '75%' }}
            >
              {t('LOGIN.RECOVER_PASSWORD_MESSAGE')}
            </Text>
            <form
              autoComplete="off"
              id="recovery-password-form"
              name="recovery-password-form"
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onSubmit={submitHandler(handleSubmit)}
            >
              <Flex direction="column" gap={10} mx="auto" w={{ base: '100%', md: '60%' }}>
                <MbeInput
                  id="mail"
                  placeholder={t('FORM.EMAIL')}
                  {...register('email', {
                    required: { value: true, message: t(ERRORS.empty) },
                    pattern: { value: emailRegex, message: t(ERRORS.email) },
                  })}
                />
                <Button disabled={isDisabled} type="submit" variant="mbePrimary">
                  {t('ACTIONS.NEXT')}
                </Button>
              </Flex>
            </form>
          </Section>
        </Container>
      </Box>
    </PlainLayout>
  );
};
